import { cookieStorage, createConfig, createStorage } from 'wagmi'
import { publicWagmiConfig } from './public'

export const DEFAULT_POLLING_INTERVAL = 4_000

export const createProductionConfig = () => {
  const storage = createStorage({
    storage: cookieStorage,
  })

  return createConfig({
    ...publicWagmiConfig,
    pollingInterval: DEFAULT_POLLING_INTERVAL,
    storage,
    ssr: true,
  })
}
